import Component from '../share/Component';
import stripIndent from 'licia/stripIndent';
import $ from 'licia/$';
import h from 'licia/h';
import map from 'licia/map';
import { exportCjs } from '../share/util';
import I18n from 'licia/I18n';
export default class Modal extends Component {
    constructor(container, options = {}) {
        super(container, { compName: 'modal' }, options);
        this.render = () => {
            const { options, c, $body } = this;
            if (!options.title) {
                $body.addClass(c('no-title'));
            }
            else {
                $body.rmClass(c('no-title'));
                this.$title.text(options.title);
            }
            if (!options.footer) {
                $body.addClass(c('no-footer'));
            }
            else {
                $body.rmClass(c('no-footer'));
                this.$footer.html('').append(options.footer);
            }
            if (!options.showClose) {
                this.$close.hide();
            }
            else {
                this.$close.show();
            }
            this.$body.css('width', options.width + 'px');
            this.renderContent();
        };
        this.hide();
        this.initOptions(options, {
            title: '',
            content: '',
            footer: '',
            showClose: true,
            width: getDefaultWidth(),
        });
        this.initTpl();
        this.$title = this.find('.title');
        this.$content = this.find('.content');
        this.$body = this.find('.body');
        this.$footer = this.find('.footer');
        this.$close = this.find('.icon-close');
        this.bindEvent();
    }
    show() {
        this.render();
        this.$container.rmClass(this.c('hidden'));
    }
    hide() {
        this.$container.addClass(this.c('hidden'));
    }
    destroy() {
        super.destroy();
        this.$container.rmClass(this.c('hidden'));
    }
    renderContent() {
        this.$content.html('').append(this.options.content);
    }
    static alert(msg) {
        return new Promise((resolve) => {
            const modal = getGlobalModal();
            const { c } = modal;
            modal.setOption({
                title: '',
                content: msg,
                width: getDefaultWidth(),
                footer: createButtons({
                    [Modal.i18n.t('ok')]: {
                        type: 'primary',
                        onclick() {
                            modal.hide();
                            resolve();
                        },
                    },
                }, c),
            });
            modal.show();
        });
    }
    static confirm(msg) {
        return new Promise((resolve) => {
            const modal = getGlobalModal();
            const { c } = modal;
            modal.setOption({
                title: '',
                content: msg,
                width: getDefaultWidth(),
                footer: createButtons({
                    [Modal.i18n.t('cancel')]: {
                        type: 'secondary',
                        onclick() {
                            modal.hide();
                            resolve(false);
                        },
                    },
                    [Modal.i18n.t('ok')]: {
                        type: 'primary',
                        onclick() {
                            modal.hide();
                            resolve(true);
                        },
                    },
                }, c),
            });
            modal.show();
        });
    }
    static prompt(title = '', defaultText = '') {
        return new Promise((resolve) => {
            const modal = getGlobalModal();
            const { c } = modal;
            const input = h('input' + c('.input'), {
                value: defaultText,
            });
            function ok() {
                modal.hide();
                resolve(input.value);
            }
            $(input).on('keypress', (e) => {
                e = e.origEvent;
                if (e.key === 'Enter') {
                    ok();
                }
            });
            modal.setOption({
                title,
                content: input,
                width: getDefaultWidth(),
                footer: createButtons({
                    [Modal.i18n.t('cancel')]: {
                        type: 'secondary',
                        onclick() {
                            modal.hide();
                            resolve(null);
                        },
                    },
                    [Modal.i18n.t('ok')]: {
                        type: 'primary',
                        onclick: ok,
                    },
                }, c),
            });
            modal.show();
            const end = input.value.length;
            input.setSelectionRange(end, end);
            input.focus();
        });
    }
    static setContainer(container) {
        globalContainer = container;
    }
    bindEvent() {
        this.$body.on('click', this.c('.icon-close'), () => this.hide());
        this.on('optionChange', this.render);
    }
    initTpl() {
        this.$container.html(this.c(stripIndent `
      <div class="body">
        <span class="icon icon-close"></span>
        <div class="title"></div>
        <div class="content"></div>
        <div class="footer"></div>
      </div>
      `));
    }
}
Modal.i18n = new I18n(navigator.language !== 'zh-CN' ? 'en-US' : 'zh-CN', {
    'en-US': {
        ok: 'OK',
        cancel: 'Cancel',
    },
    'zh-CN': {
        ok: '确定',
        cancel: '取消',
    },
});
let globalModal = null;
let globalContainer = null;
function getGlobalModal() {
    if (!globalContainer) {
        globalContainer = h('div');
        document.body.append(globalContainer);
    }
    if (!globalModal) {
        globalModal = new Modal(globalContainer, {
            showClose: false,
        });
    }
    return globalModal;
}
function createButtons(buttons, c) {
    const buttonEls = map(buttons, (button, key) => {
        return h(c('.button') + c('.' + button.type), {
            onclick: button.onclick,
        }, key);
    });
    return h(c('.button-group'), {}, ...buttonEls);
}
function getDefaultWidth() {
    if (window.innerWidth < 500) {
        return window.innerWidth - 16 * 2;
    }
    return 500;
}
if (typeof module !== 'undefined') {
    exportCjs(module, Modal);
}
